import { createEvent } from '@cobuildlab/react-simple-state';
import { UserSession } from './session-types';

export const OnSession = createEvent<UserSession>();
export const OnSessionError = createEvent<Error>();
